export default __webpack_public_path__ + "static/media/email-color.5b05c06b.svg";